import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const GET_ALL_PARTNERS = "GET_ALL_PARTNERS";
export const GET_ALL_PARTNERS_SUCCESS = "GET_ALL_PARTNERS_SUCCESS";
export const GET_ALL_PARTNERS_FAILED = "GET_ALL_PARTNERS_FAILED";
export const GET_ALL_PRODUCT_TYPES = "GET_ALL_PRODUCT_TYPES";
export const GET_ALL_PRODUCT_TYPES_SUCCESS = "GET_ALL_PRODUCT_TYPES_SUCCESS";
export const GET_ALL_PRODUCT_TYPES_FAILED = "GET_ALL_PRODUCT_TYPES_FAILED";
export const GET_ED_ORDERS_SUMMARY = "GET_ED_ORDERS_SUMMARY";
export const GET_ED_ORDERS_SUMMARY_SUCCESS = "GET_ED_ORDERS_SUMMARY_SUCCESS";
export const GET_ED_ORDERS_SUMMARY_FAILED = "GET_ED_ORDERS_SUMMARY_FAILED";
export const RESET_ED_ORDERS_SUMMARY = "RESET_ED_ORDERS_SUMMARY";

export function fetchUpdatedTimestamp(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}edOrdersSummary`,
      dispatch,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: obj?.callback,
    };
    makeAPICall(params);
  };
}

export function getAllPartners(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}wireLineJioFiber`,
      dispatch,
      defaultAction: GET_ALL_PARTNERS,
      successAction: GET_ALL_PARTNERS_SUCCESS,
      failedAction: GET_ALL_PARTNERS_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: obj.callback,
    };
    makeAPICall(params);
  };
}

export function getAllProductTypes(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}edOrdersSummary`,
      dispatch,
      defaultAction: GET_ALL_PRODUCT_TYPES,
      successAction: GET_ALL_PRODUCT_TYPES_SUCCESS,
      failedAction: GET_ALL_PRODUCT_TYPES_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: obj?.callback,
    };
    makeAPICall(params);
  };
}

export function getEdOrdersSummaryData(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}edOrdersSummary`,
      dispatch,
      defaultAction: GET_ED_ORDERS_SUMMARY,
      successAction: GET_ED_ORDERS_SUMMARY_SUCCESS,
      failedAction: GET_ED_ORDERS_SUMMARY_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
    };
    makeAPICall(params);
  };
}

export function resetEdOrdersSummary() {
  return {
    type: RESET_ED_ORDERS_SUMMARY,
  };
}
